import {
    INotificationProperties,
    Notification,
    createNotification,
} from '@vfde-brix/ws10/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { getAvcNotificationProps, getAvcNotificationTooltip } from 'Container/AvailabilityCheck/util/result';
import { mountToolTip } from './tooltip';
import { HtmlId, ResultHtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';
import { AvcResult } from '@vfde-sails/avc-core';
import { HtmlSelector } from '../constants';
import { getCMSConfig } from '../util/cms';
import { debugInfo } from '../util/debug';
import { HomesPassedType } from 'app/enums/product';

export const mountNotification = (id: HtmlId, props?: INotificationProperties) =>
    mountComponent(id, createNotification, props ?? NO_PATTERN_BUSINESS_LOGIC);

export const mountNotificationServiceError = (id: HtmlId, hotlineSelector: HtmlSelector) => {
    const hotlineNumber = getCMSConfig()?.hotlineNumber;

    if (!hotlineNumber) {
        debugInfo('Hotline number was not found in config.');
        return;
    }

    const notificationElement = document.getElementById(id);
    const hotlineElement = notificationElement?.querySelector(hotlineSelector);

    if (!hotlineElement) {
        debugInfo('Hotline element was not found inside Notification with id: ', id);
        return;
    }

    hotlineElement.innerHTML = hotlineNumber;
};

export const updateAvcNotification = (
    comp: Notification | undefined,
    avcResult: AvcResult,
    isPreFiber: boolean,
    homesPassedType?: HomesPassedType,
    accessSupplier?: string,
    availabilityIndicator?: string,
) => {
    if (!comp) {
        return;
    }

    comp.update(getAvcNotificationProps(
        avcResult,
        isPreFiber,
        homesPassedType,
        accessSupplier,
        availabilityIndicator
    ));

    const tooltip = getAvcNotificationTooltip(avcResult);

    tooltip && mountToolTip(ResultHtmlId.TOOLTIP, {
        stdHeadline: tooltip.headline,
        stdTooltipId: ResultHtmlId.TOOLTIP,
        txtContent: tooltip.text,
        business: NO_PATTERN_BUSINESS_LOGIC,
    });
};
